import { CircularProgress } from "@mui/material";

interface Props {
    isSubmitting: boolean,
    valueLoading?: string,
    valueInput?: string,
    disabled?: boolean
}

export const FormButton = ({ isSubmitting, valueLoading = "Guardando", valueInput = "Guardar", disabled = false }: Props) => {


    return (
        <button
            type="submit"
            className={`w-full rounded-md p-2 font-bold text-white ${isSubmitting || disabled ? 'bg-slate-300 cursor-not-allowed' : 'bg-blue-cole hover:bg-blue-700'} transition-colors duration-200 ease-in-out`}
            disabled={isSubmitting || disabled}
        >
            {isSubmitting ? (
                <div className="flex items-center justify-center">
                    <CircularProgress size={24} className="text-white" />
                    <span className="ml-2">{valueLoading}...</span>
                </div>
            ) : (
                <span>{valueInput}</span>
            )}
        </button>
    );
}